var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"rkm-navbar-nav-icon",attrs:{"pill":""},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('rkm-icon',{attrs:{"icon":"bars"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }